import React, { useState } from 'react';
import getConfig from 'next/config';
import { Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import styles from './style';
import MbbBanner from './MbbBanner';
import MbbOfferCardContainer from './MbbOfferCardContainer';
import MbbDevicesContainer from './MbbDevicesContainer';
import FaqContainer from './FaqContainer';
import BroadbandContentCarousel from '../eir-broadband/BroadbandContentCarousel';
import getGeneralImage from '../../../util/getGeneralImage';

const { publicRuntimeConfig } = getConfig();

const MbbContainer = ({ cmsData = {}, showOnBroadband = false, cmsMBBTitle }) => {
  const theme = useTheme();
  const [showMbbDevice, setShowMbbDevice] = useState(false);
  const [mbbDevicesCards, setMbbDevicesCards] = useState([]);
  const [selectedAddOnCode, setSelectedAddOnCode] = useState('');
  const [OfferCode, setOfferCode] = useState('');

  return (
    <Grid container sx={showOnBroadband && { pb: 11 }}>
      {!showOnBroadband && (
        <Grid
          item
          xs={12}
          sx={
            styles(
              theme,
              `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
                getGeneralImage({
                  generalImageArray: cmsData?.attributes?.GeneralImage_Mobile,
                  key: 'afterPrequal',
                  view: 'MobileViewImage',
                }).url
              }`
            ).PrequalContainer
          }
        >
          <MbbBanner
            desktopImage={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
              getGeneralImage({
                generalImageArray: cmsData?.attributes?.GeneralImage_Mobile,
                key: 'primaryBannerCurveImage',
                view: 'DesktopViewImage',
              }).url
            }`}
            mobileImage={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
              getGeneralImage({
                generalImageArray: cmsData?.attributes?.GeneralImage_Mobile,
                key: 'primaryBannerCurveImage',
                view: 'MobileViewImage',
              }).url
            }`}
            desktopImageAlt={
              getGeneralImage({
                generalImageArray: cmsData?.attributes?.GeneralImage_Mobile,
                key: 'primaryBannerCurveImage',
                view: 'DesktopViewImage',
              }).alt
            }
            mobileImageAlt={
              getGeneralImage({
                generalImageArray: cmsData?.attributes?.GeneralImage_Mobile,
                key: 'primaryBannerCurveImage',
                view: 'MobileViewImage',
              }).alt
            }
            cmsMBBTitle={cmsMBBTitle}
          />
        </Grid>
      )}
      <Grid item xs={12} sx={{ background: theme.palette.secondary.contrastText }}>
        <MbbOfferCardContainer
          setShowMbbDevice={setShowMbbDevice}
          setOfferCode={setOfferCode}
          cmsDataImg={cmsData}
          simOnly
          setMbbDevicesCards={setMbbDevicesCards}
          mbbDevicesCards={mbbDevicesCards}
          setSelectedAddOnCode={setSelectedAddOnCode}
          showOnBroadband={showOnBroadband}
          cmsData={cmsData?.attributes}
        />
      </Grid>
      {showMbbDevice && (
        <Grid item xs={12} sx={{ background: theme.palette.secondary.contrastText }}>
          <MbbDevicesContainer
            key={showMbbDevice}
            showMbbDevice={showMbbDevice}
            setShowMbbDevice={setShowMbbDevice}
            OfferCode={OfferCode}
            cmsDataImg={cmsData}
            setMbbDevicesCards={setMbbDevicesCards}
            mbbDevicesCards={mbbDevicesCards}
            selectedAddOnCode={selectedAddOnCode}
          />
        </Grid>
      )}
      {!showOnBroadband && (
        <Grid item xs={12} sx={{ background: theme.palette.secondary.contrastText }}>
          <BroadbandContentCarousel
            contentTitle={cmsData?.attributes?.EirInformation_MbbContentTiles?.title}
            contentDescription={cmsData?.attributes?.EirInformation_MbbContentTiles?.description}
            contentCarousel={cmsData?.attributes?.MbbContentTiles}
            useH1={cmsData?.attributes?.EirInformation_MbbContentTiles?.useH1}
          />
        </Grid>
      )}
      {!showOnBroadband && (
        <Grid
          xs={12}
          sx={{
            background: theme.palette.primary.backgroundColor3,
            ...styles(theme).faqContainerSuperMain,
          }}
        >
          <FaqContainer
            InsuranceHeading={cmsData.attributes.MBB_FAQ_Title}
            InsuranceList={cmsData.attributes.MBB_FAQ_List}
          />
        </Grid>
      )}
    </Grid>
  );
};
export default MbbContainer;
